<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong>
                        Canteen Fee Structure
                    </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row dense justify="center">
                <v-col sm="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="current_academic_year" :items="academic_year_list"
                        item-text="ay" return-object label="Academic Year" outlined persistent-hint
                        hint="Please Select Academic Year"></v-autocomplete>
                </v-col>
                <v-col sm="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="stream" :items="stream_list" item-text="name"
                        item-value="id" label="Stream" outlined @change="getStreamData();" persistent-hint
                        hint="Please Select Stream"></v-autocomplete>
                </v-col>
                <v-col sm="3" v-if="standard_list != ''">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="std" multiple :items="standard_list"
                        item-text="standard" item-value="id" label="Standard" outlined persistent-hint
                        hint="Please Select Standard"></v-autocomplete>
                </v-col>
                <v-col sm="3" v-if="canteen_menu_type_list != ''">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="menu_type" :items="canteen_menu_type_list"
                        item-text="name" item-value="id" label="Menu Type" outlined persistent-hint
                        hint="Please Select Menu Type"></v-autocomplete>
                </v-col>
                <v-row dense justify="center">

                    <v-col sm="3">
                        <v-icon color="error">*</v-icon>
                        <v-text-field type="number" class="padding-bot" persistent-hint hint="Please Enter Fee"
                            label="Enter Fee" outlined rounded dense v-model="amount"></v-text-field>
                    </v-col>
                    <v-col sm="3" v-if="canteen_menu_type_list != ''">
                        <v-icon color="error">*</v-icon>
                        <v-text-field type="number" class="padding-bot" persistent-hint hint="Please Monthly Fee"
                            label="Enter Monthly Fee" outlined rounded dense v-model="monthly_fees"></v-text-field>
                    </v-col>
                    <v-col sm="3" v-if="canteen_menu_type_list != ''">
                        <v-icon color="error">*</v-icon>
                        <v-text-field type="number" class="padding-bot" persistent-hint
                            hint="Please Monthly Additional Fee" label="Enter Monthly Additional Fee" outlined rounded
                            dense v-model="monthly_additional_fees"></v-text-field>
                    </v-col>
                     <v-col sm="3" v-if="canteen_menu_type_list != ''">
                        <v-icon color="error">*</v-icon>
                        <v-text-field type="number" class="padding-bot" persistent-hint hint="Please Daily fee"
                            label="Enter Daily Fee" outlined rounded dense v-model="per_day_fees"></v-text-field>
                    </v-col>
                    <v-col sm="3">
                        <v-icon color="error"></v-icon>
                        <v-file-input v-model="attachments" placeholder="Upload Menu Card if any" label="Menu Card" outlined rounded dense
                            prepend-icon="mdi-paperclip">
                            <template v-slot:selection="{ text }">
                                <v-chip small label color="primary">{{ text }}</v-chip>
                            </template>
                        </v-file-input>
                    </v-col>
                    <!-- <v-col sm="3">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete rounded dense required v-model="canteen_inst_type"
                            :items="canteen_installment_type_list" item-text="name" item-value="id"
                            label="Canteen Installment Type" outlined persistent-hint
                            hint="Please Select Canteen Installment Type"></v-autocomplete>
                    </v-col> -->
                    <v-col sm="3"></v-col>
                    <v-col sm="3"></v-col>
                    <v-col sm="3"></v-col>
                </v-row>


            </v-row>
            <!-- <v-row dense>
                <v-col sm="3">
                    <v-icon color="error"></v-icon>
                    <v-file-input v-model="attachments" placeholder="Upload Menu Card if any" label="Menu Card"
                        prepend-icon="mdi-paperclip">
                        <template v-slot:selection="{ text }">
                            <v-chip small label color="primary">{{ text }}</v-chip>
                        </template>
                    </v-file-input>
                </v-col>
            </v-row> -->
            <v-row dense justify="center">
                <v-col sm="2">
                    <v-btn rounded class="button mt-6" :loading="loader" @click="addFee()">Add Canteen Fee</v-btn>
                </v-col>
            </v-row>
        </v-card>
        <v-card class="box" v-if="canteen_fees_list != ''">
            <v-data-table :headers="headers" :items="bookList1" :search="search" class="elevation-1 mytable" dense
                v-if="canteen_fees_list != ''" @current-items="getFiltered">
                <template v-slot:[`item.fees`]="{ item }">
                    <v-row dense>
                        <v-col cols="12" md="8" sm="8">
                            <v-text-field type="number" class="pt-3" persistent-hint hint="Enter Canteen Fee"
                                label="Enter Canteen Fee" outlined rounded dense v-model="item.fees"></v-text-field>
                        </v-col>

                        <v-col cols="12" md="4" sm="4" class="d-flex justify-center">
                            <v-btn rounded class="button mt-4" style="font-size: 10px;" small @click="editFee(item)">Update</v-btn>
                        </v-col>
                    </v-row>
                </template>
                <template v-slot:[`item.monthly_fees`]="{ item }">
                    <v-row dense>
                        <v-col cols="12" md="8" sm="8">
                            <v-text-field type="number" class="pt-3" persistent-hint hint="Enter Monthly Fee"
                                label="Enter Monthly Fee" outlined rounded dense
                                v-model="item.monthly_fees"></v-text-field>
                        </v-col>

                        <v-col cols="12" md="4" sm="4" class="d-flex justify-center">
                            <v-btn rounded class="button mt-4 " style="font-size: 10px;" small @click="editmonthlyfees(item)">Update</v-btn>
                        </v-col>
                    </v-row>
                </template>
                <template v-slot:[`item.monthly_additional_fees`]="{ item }">
                    <v-row dense>
                        <v-col cols="12" md="8" sm="8">
                            <v-text-field type="number" class="pt-3" persistent-hint hint="Enter Additional Fee"
                                label="Enter Additional Fee" outlined rounded dense
                                v-model="item.monthly_additional_fees"></v-text-field>
                        </v-col>
                        <!-- <v-col cols="12" md="1" sm="1"></v-col> -->

                        <v-col cols="12" md="4" sm="4" class="d-flex justify-center">
                            <v-btn rounded class="button mt-4 " small style="font-size: 10px;"
                                @click="editmonthlyadditionalfees(item)">Update</v-btn>
                        </v-col>
                    </v-row>
                </template>
                  <template v-slot:[`item.per_day_fees`]="{ item }">
                    <v-row dense>
                        <v-col cols="12" md="8" sm="8">
                            <v-text-field type="number" class="pt-3" persistent-hint hint="Enter Daily Fee"
                                label="Enter Daily Fee" outlined rounded dense
                                v-model="item.per_day_fees"></v-text-field>
                        </v-col>
                        <!-- <v-col cols="12" md="1" sm="1"></v-col> -->

                        <v-col cols="12" md="4" sm="4" class="d-flex justify-center">
                            <v-btn rounded class="button mt-4 " small style="font-size: 10px;"
                                @click="editperdayfees(item)">Update</v-btn>
                        </v-col>
                    </v-row>
                </template>
                <template v-slot:top class="pb-5">
                    <v-row dense justify="center" align="center">
                        <tr class="t-row">
                            <div>
                                <th>
                                    <v-row>
                                        <span v-for="header in headers" :key="header.text">
                                            <span v-if="filters.hasOwnProperty(header.value)">
                                                <v-autocomplete class="mr-2 pb-5 pt-2" flat hide-details small rounded
                                                    dense outlined color="#0F2027" :label="header.text" multiple
                                                    clearable :items="columnValueList(header.value)"
                                                    v-model="filters[header.value]"></v-autocomplete>
                                            </span>
                                        </span>
                                    </v-row>
                                </th>
                            </div>
                        </tr>
                    </v-row>
                </template>
                <template v-slot:[`item.isactive`]="{ item }">
                    <v-switch v-model="item.isactive" @change="changeActiveStatus(item)"></v-switch>
                </template>
                <!-- <template v-slot:[`item.menu_card`]="{ item }">
                  <span v-if="item.menu_card">
                          <strong>Download Menu Card </strong>
                          <a target="_blank" :href="aws_path +item.menu_card" download="menu_card"><v-icon>mdi-download</v-icon></a>
                      </span>
                      <span v-else>--</span> 
              </template>-->
                <template v-slot:[`item.menu_card`]="{ item }">
                    <span v-if="item.menu_card">
                        <a class="p-2" :href="aws_path + item.menu_card" target="blank">
                            <v-tooltip top>
                                <template v-slot:activator="{ attrs }">
                                    <v-btn icon v-if="item.menu_card != null" v-bind="attrs"> <v-icon
                                            color="black">mdi-eye</v-icon></v-btn>
                                </template>
                                <span> View Attachment File!!! </span>
                            </v-tooltip>
                        </a>
                    </span>
                    <!-- </span>    -->
                </template>

                <template v-slot:[`item.edit`]="{ item }">
                    <v-avatar style="" size="25" class="edit-avatar">
                        <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
                    </v-avatar>
                </template>
            </v-data-table>
        </v-card>
        <v-dialog v-model="edit_dialog" max-width="500px">
            <v-card>
                <v-card-text>
                    <v-container>
                        <v-row dense justify="center">
                            <v-col cols="12">
                                <v-file-input v-model="edit_attachment" placeholder="Upload attachment if any"
                                    label="Attachment" prepend-icon="mdi-paperclip">
                                    <template v-slot:selection="{ text }">
                                        <v-chip small label color="primary">{{ text }}</v-chip>
                                    </template>
                                </v-file-input>
                            </v-col>
                            <template v-if="editedItem.attachment">
                                <h3>Manu Card</h3>
                                <a class="p-2" :href="aws_path + editedItem.attachment" target="blank">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ attrs }">
                                            <v-btn icon v-if="editedItem.attachment != null" v-bind="attrs"> <v-icon
                                                    color="black">mdi-eye</v-icon></v-btn>
                                        </template>
                                        <span> View Attachment File!!! </span>
                                    </v-tooltip>
                                </a>
                            </template>
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="edit_dialog = false">Cancel</v-btn>
                    <v-btn color="blue darken-1" :loading="edit_save_attachment_load" text
                        @click="editFeeMenu()">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
    data() {
        return {
            edit_attachment: null,
            edit_save_attachment_load: false,
            attachments: null,
            edit_dialog: false,
            // extraBreadcrumbItems: [


            // ],
            breadcrumbClass: "breadcrumb-style1",
            aws_path: null,
            loader: false,
            color: "",
            snackbar: false,
            search: null,
            snackbar_msg: null,
            current_academic_year: null,
            stream: null,
            div: [],
            std: "",
            academic_year_list: null,
            standard_list: null,
            stream_list: null,
            stream: "",
            amount: null,
            monthly_fees: null,
            per_day_fees: null,
            monthly_additional_fees: null,
            //  canteen_inst_type: null,
            canteen_fees_list: [],
            loader: false,
            filterArr: [],
            canteen_menu_type_list: [],
            //canteen_installment_type_list: [],
            menu_type: null,
            filters: {
                standard: [],
                academicyear: [],
                canteenmenutype: [],
            },
            headers: [
                { text: "Academic Year", value: "academicyear" },
                { text: "Standard", value: "standard" },
                { text: "Isactive", value: "isactive" },
                // { text: "Installment Type", value: "canteen_inst_type" },
                { text: "Canteen Fees", value: "fees" },
                { text: "Menu Card", value: "menu_card" },
                { text: "Edit", value: "edit" },

            ],
            editedItem: {
                id: "",
                attachment: null,
            },
        };
    },
    computed: {
        bookList1() {
            return this.canteen_fees_list.filter((d) => {
                return Object.keys(this.filters).every((f) => {
                    return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                });
            });
        },
    },
    created() {
        this.aws_path = localStorage.getItem("awspath");
    },
    methods: {
        editItem(item) {
            this.editedItem.id = item.id;
            this.editedItem.attachment = item.menu_card;
            this.edit_dialog = true;
        },
        getFiltered(e) {
            this.filterArr = e;
        },
        columnValueList(val) {
            return this.canteen_fees_list.map((d) => d[val]);
        },
        editFeeMenu() {
            let formData = new FormData();
            formData.append("id", this.editedItem.id);
            formData.append("attachment", this.edit_attachment);
            this.loader = true;
            axios
                .post("/Canteen/editFeeMenu", formData)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.loader = false;
                        this.showSnackbar("#4caf50", "Save successfully");
                        this.attachments = null;
                        this.onload();
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    this.loader = false;
                })
                .finally(() => {
                    this.loader = false;
                    this.edit_dialog = false;
                });
        },
        editFee(item) {
            const data = {
                canteen_fees_data: item,
            };
            axios
                .post("/Canteen/editCanteenFeeStructure", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", "Save successfully");
                        this.onload();
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                })
                .finally(() => { });
        },
        editmonthlyfees(item) {
            const data = {
                canteen_fees_data: item,
            };
            axios
                .post("/Canteen/editCanteenMonthlyStructure", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", "Save successfully");
                        this.onload();
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                })
                .finally(() => { });
        },
        editmonthlyadditionalfees(item) {
            const data = {
                canteen_fees_data: item,
            };
            axios
                .post("/Canteen/editCanteenMonthlyAdditionalFeesStructure", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", "Save successfully");
                        this.onload();
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                })
                .finally(() => { });
        },
          editperdayfees(item) {
            const data = {
                canteen_fees_data: item,
            };
            axios
                .post("/Canteen/editCanteenPerDayFees", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", "Save successfully");
                        this.onload();
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                })
                .finally(() => { });
        },
        fnExcelReport(id, name) {
            var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
            tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
            tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
            tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
            tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
            tab_text = tab_text + "<table border='1px'>";
            var exportTable = $("#" + id).clone();
            exportTable.find("input").each(function (index, elem) {
                $(elem).remove();
            });
            tab_text = tab_text + exportTable.html();
            tab_text = tab_text + "</table></body></html>";
            var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

            //Save the file
            // var blob = new Blob([tab_text], { type: "application/vnd.ms-excel;charset=utf-8" });
            // window.saveAs(blob, fileName);
            const blob = new Blob([tab_text], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
            const filename = name + ".xls";

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                // For IE
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                // For modern browsers
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(url);
            }
        },
        ExportToExcel() {
            var htmltable = document.getElementById("my-table-id");
            var html = htmltable.outerHTML;
            window.open("data:application/vnd.ms-excel," + encodeURIComponent(html));
        },
        changeActiveStatus(item) {
            const data = {
                canteen_fees_data: item,
            };
            axios
                .post("/Canteen/changeActiveStatus", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", "Save successfully");
                        this.onload();
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                })
                .finally(() => { });
        },
        addFee() {
            //  const data = {
            //       ay: this.current_academic_year.id,
            //       stream: this.stream,
            //       std: this.std,
            //       fees: this.amount,
            //       attachment: this.attachments,
            //   };
            let formData = new FormData();
            if (this.std.length > 1) {
                for (var i = 0; i < this.std.length; i++) {
                    if (this.std[i] != "") {
                        let standrd = this.std[i];
                        formData.append("std", standrd);
                    }
                }
            } else {
                formData.append("std", this.std);
            }
            formData.append("ay", this.current_academic_year.id);
            //formData.append("std", this.std);
            formData.append("stream", this.stream);
            formData.append("fees", this.amount);
            formData.append("monthly_fees", this.monthly_fees);
            formData.append("per_day_fees", this.per_day_fees);
            formData.append("monthly_additional_fees", this.monthly_additional_fees);
            //formData.append("canteen_inst_type", this.canteen_inst_type);
            formData.append("attachment", this.attachments);
            formData.append("menu_type", this.menu_type);
            this.loader = true;
            axios
                .post("/Canteen/saveCanteenFeeStructure", formData)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.loader = false;
                        this.showSnackbar("#4caf50", "Save successfully");
                        this.attachments = null;
                        this.onload();
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    this.loader = false;
                })
                .finally(() => {
                    this.loader = false;
                });
        },
        getStreamData() {
            const data = {
                ay: this.current_academic_year.id,
                stream: this.stream,
            };
            axios
                .post("/Canteen/getStreamData", data)
                .then((res) => {
                    if (res.data.flag == "NO") {
                        this.showSnackbar("#b71c1c", "No division for this stream / Stream mapping not done for selected stream!!!"); // show snackbar on error
                        return;
                    }
                    if (res.data.flag == "YES") {
                        this.standard_list = res.data.standard_list;
                    } else {
                        //error
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {
                    //close loader
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        onload() {
            axios
                .post("/Canteen/getCanteenFeeStructure")
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.academic_year_list = res.data.ay_data;
                        this.current_academic_year = res.data.cay;
                        this.stream_list = res.data.stream_list_without_all;
                        this.canteen_menu_type_list = res.data.canteen_menu_type_list;
                        this.canteen_fees_list = res.data.canteen_fees_list;
                        //  this.canteen_installment_type_list = res.data.canteen_installment_type_list
                        console.log(this.headers)
                        if (res.data.show_menu_type == "YES") {
                            if (this.headers.some((head) => head.value === "canteenmenutype")) {
                            } else {
                                this.headers.splice(3, 0, {
                                    text: "Menu Type",
                                    value: "canteenmenutype",
                                    sortable: true,
                                })
                                this.headers.splice(5, 0, {
                                    text: "Monthly Fees",
                                    value: "monthly_fees",
                                    sortable: true,
                                })
                                this.headers.splice(6, 0, {
                                    text: "Monthly Additional Fees",
                                    value: "monthly_additional_fees",
                                    sortable: true,
                                })
                                 this.headers.splice(7, 0, {
                                    text: "Daily Fees",
                                    value: "per_day_fees",
                                    sortable: true,
                                })
                            }
                        }
                    } else {
                        //error
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {
                    //close loader
                    this.get_ay_std_ft_loader = false;
                });
        },
    },
    mounted() {
        this.onload();
    },
};
</script>
<style scoped></style>
